import axios from "axios";

import { authenticateStrapiUser } from "./dataLoad.js";
const crypto = require("crypto");
const fs = require("fs");

export default {
  state: {
    sessionId: null,
    applicationId: null,
  },
  getters: {
    getSessionId: (state) => state.sessionId,
    getApplicationId: (state) => state.applicationId,
  },
  mutations: {
    setSessionId(state, sessionId) {
      state.sessionId = sessionId;
    },
    setApplicationId(state, appId) {
      state.applicationId = appId;
    },
  },
  actions: {
    // async addQnaDatatoStrapi({ getters }, qnaData) {
    //     console.log(process.env.strapi_password,process.env.strapi_username,process.env.VUE_APP_I18N_LOCALE,"this is creds");
    //     const jwtToken = await  authenticateStrapiUser('adminofchester','1@#Backguard')

    //     // console.log(jwtToken,"this is the token needed");
    //     let config = {
    //         method: 'post',
    //         maxBodyLength: Infinity,
    //         url: 'https://cms.chester.arsconnect.com/qnas',
    //         headers: {
    //             'Content-Type': 'application/json',
    //             Authorization: `Bearer ${jwtToken}`,
    //         },
    //         data: qnaData
    //     };
    //     axios.request(config)
    //         .then((response) => {
    //             //console.log(JSON.stringify(response.data));
    //         })
    //         .catch((error) => {
    //             console.log(error);
    //         });
    // },
    generateSession({ commit }) {
      commit(
        "setSessionId",
        crypto.randomBytes(50).toString("hex").slice(0, 20)
      );
    },
    async addSessionDataToStrapi({ getters }, sessionData) {
      let config = {
        method: "post",
        maxBodyLength: Infinity,
        url: "https://cms.wnm.arsconnect.com/user-sessions",
        headers: {
          // 'Content-Type': 'application/json',
          // Authorization: `Bearer ${jwtToken}`,
        },
        data: sessionData,
      };
      axios
        .request(config)
        .then((response) => {
          //console.log(JSON.stringify(response.data));
          console.log("Session Data Added");
        })
        .catch((error) => {
          console.log(error);
        });
    },
    addInteractionToPostgres({ getters }, actionData) {
        console.log("Calling addInteractionToPostgres",actionData);
      let date = new Date();
      let config = {
        method: "post",
        maxBodyLength: Infinity,
        url: "https://us-central1-project-bluebox.cloudfunctions.net/analyticsPostgres/analytics",
        headers: {
          "Content-Type": "application/json",
          secret_key: "4GF7JKZ9PQ2WM6TN5XB8R1VC3LQD7FHJ",
        },
        data: {
          applicationId: getters.getApplicationId,
          sessionId: getters.getSessionId,
          actionType: actionData.actionType,
          payload: actionData.actionPayload,
          timestamp: date.toISOString(),
        },
      };
      axios
        .request(config)
        .then((response) => {
          console.log("Response from Postgres:",response);
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
};
